// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__zRs98"};